export const ORG_FIELD = {
  ID: 'id',
  NAME: 'name',
  DOMAIN: 'domain',
  ACTIVE: 'active',
  LOGO_ID: 'logoFileId',
  LOGO_URL: 'logoFilePath',
  IS_UNPAID: 'unpaid',
  IS_FREE_TRIAL: 'freeTrial',
  FREE_TRIAL_END_DT: 'freeTrialStopDt',
  FREE_TRIAL_DAYS_COUNT: 'remainFreeTrialDays',
  CREATED_DT: 'createdDt',
  UPDATED_DT: 'updatedDt',
  OWNER_ID: 'ownerId',
  OWNER_NAME: 'ownerName',
  OWNER_EMAIL: 'ownerEmail',
} as const;

export const ORG_INITIAL_VALUES = {
  [ORG_FIELD.NAME]: '',
  [ORG_FIELD.DOMAIN]: '',
} as const;

// reserved domains
export const RESERVED_DOMAINS = [
  'www',
  'contiple',
  'console',
  'auth',
  'docs',
  'billing',
  'api',
  'chat',
  'livechat',
  'bot',
  'call',
  'swat',
  'meet',
  'talk',
  'softphone',
  'phone',
  'veloce',
  'helpcenter',
  'help',
  'voc',
  'hub',
  'master',
];

export const DOMAIN_NOT_ALLOWED_WORD = 'admin';
